import { useTheme } from 'next-themes'
import React from 'react'
import { ThemeProvider } from 'styled-components'

const StyledComponentsProvider: React.FC = ({ children }) => {
  const { theme } = useTheme()

  return (
    <ThemeProvider theme={(defaultTheme) => ({ ...defaultTheme, isDark: theme === 'dark' })}>{children}</ThemeProvider>
  )
}

export default StyledComponentsProvider
